// function initializeSlider() {
//   const container = document.querySelector(".customer-review-section");
//   const sliderWrapper = document.querySelector(".slider-wrapper");
//   const slideItems = document.querySelectorAll(".slide-item");
//   const dots = document.querySelectorAll(".nav-dot");

//   if (!container || !sliderWrapper || slideItems.length === 0) return;

//   const containerWidth = container.offsetWidth;
//   const slideItemWidth = slideItems[0].offsetWidth;
//   let gap = 253;
//   const windowWidth = window.innerWidth;

//   if (windowWidth < 749) {
//     gap = 0;
//   } else if (windowWidth < 1100) {
//     gap = 150;
//   }
//   const itemWithGap = slideItemWidth + gap;
//   const offsetToCenter = (containerWidth - slideItemWidth) / 2;

//   let activeIndex = 1;

//   dots.forEach((dot, index) => {
//     if (dot.classList.contains("active")) {
//       activeIndex = index;
//     }
//   });

//   function updateSlider(index) {
//     const translateAmount = offsetToCenter - index * itemWithGap;
//     sliderWrapper.style.transform = `translateX(${translateAmount}px)`;
//     dots.forEach(d => d.classList.remove("active"));
//     if (dots[index]) dots[index].classList.add("active");
//     activeIndex = index;
//   }

//   updateSlider(activeIndex);

//   // Handle dot clicks
//   dots.forEach((dot, index) => {
//     dot.addEventListener("click", () => updateSlider(index));
//   });

//   // Touch functionality
//   let startX = 0;
//   let isDragging = false;

//   sliderWrapper.addEventListener("touchstart", (e) => {
//     startX = e.touches[0].clientX;
//     isDragging = true;
//   });

//   sliderWrapper.addEventListener("touchmove", (e) => {
//     if (!isDragging) return;
//     const diffX = e.touches[0].clientX - startX;
//     // Optional: Add some temporary movement effect
//     sliderWrapper.style.transform = `translateX(${offsetToCenter - activeIndex * itemWithGap + diffX}px)`;
//   });

//   sliderWrapper.addEventListener("touchend", (e) => {
//     if (!isDragging) return;
//     const endX = e.changedTouches[0].clientX;
//     const diffX = endX - startX;
//     isDragging = false;

//     if (Math.abs(diffX) > 50) {
//       if (diffX < 0 && activeIndex < slideItems.length - 1) {
//         updateSlider(activeIndex + 1);
//       } else if (diffX > 0 && activeIndex > 0) {
//         updateSlider(activeIndex - 1);
//       } else {
//         updateSlider(activeIndex); // snap back
//       }
//     } else {
//       updateSlider(activeIndex); // not enough swipe distance
//     }
//   });
// }

// window.addEventListener("load", initializeSlider);
// window.addEventListener("resize", initializeSlider);

function initializeSlider() {
  const container = document.querySelector(".customer-review-section");
  const sliderWrapper = document.querySelector(".slider-wrapper");
  const slideItems = document.querySelectorAll(".slide-item");
  const dots = document.querySelectorAll(".nav-dot");

  if (!container || !sliderWrapper || slideItems.length === 0) return;

  const containerWidth = container.offsetWidth;
  const slideItemWidth = slideItems[0].offsetWidth;
  let gap = 253;
  const windowWidth = window.innerWidth;

  if (windowWidth < 749) {
    gap = 0;
  } else if (windowWidth < 1100) {
    gap = 150;
  }

  const itemWithGap = slideItemWidth + gap;
  const offsetToCenter = (containerWidth - slideItemWidth) / 2;

  let activeIndex = 1;

  dots.forEach((dot, index) => {
    if (dot.classList.contains("active")) {
      activeIndex = index;
    }
  });

  function updateSlider(index) {
    const clampedIndex = Math.max(0, Math.min(index, slideItems.length - 1));
    const translateAmount = offsetToCenter - clampedIndex * itemWithGap;
    sliderWrapper.style.transform = `translateX(${translateAmount}px)`;
    dots.forEach(d => d.classList.remove("active"));
    if (dots[clampedIndex]) dots[clampedIndex].classList.add("active");
    activeIndex = clampedIndex;
  }

  updateSlider(activeIndex);

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => updateSlider(index));
  });

  // Touch navigation
  let startX = 0;
  let isDragging = false;

  sliderWrapper.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
  });

  sliderWrapper.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    const diffX = e.touches[0].clientX - startX;
    sliderWrapper.style.transform = `translateX(${offsetToCenter - activeIndex * itemWithGap + diffX}px)`;
  });

  sliderWrapper.addEventListener("touchend", (e) => {
    if (!isDragging) return;
    const endX = e.changedTouches[0].clientX;
    const diffX = endX - startX;
    isDragging = false;

    if (Math.abs(diffX) > 50) {
      if (diffX < 0 && activeIndex < slideItems.length - 1) {
        updateSlider(activeIndex + 1);
      } else if (diffX > 0 && activeIndex > 0) {
        updateSlider(activeIndex - 1);
      } else {
        updateSlider(activeIndex);
      }
    } else {
      updateSlider(activeIndex);
    }
  });

  // Manual scroll trigger with shift+wheel or trackpad horizontal scroll
  let scrollThrottle = false;
  container.addEventListener("wheel", (e) => {
    const isHorizontalScroll = e.shiftKey && Math.abs(e.deltaY) > 0 || Math.abs(e.deltaX) > 0;
    if (!isHorizontalScroll || scrollThrottle) return;

    e.preventDefault();
    scrollThrottle = true;

    const direction = (e.deltaX > 0 || (e.shiftKey && e.deltaY > 0)) ? 1 : -1;
    const newIndex = activeIndex + direction;

    updateSlider(newIndex);

    setTimeout(() => {
      scrollThrottle = false;
    }, 400);
  }, { passive: false });
}

window.addEventListener("load", initializeSlider);
window.addEventListener("resize", initializeSlider);
